export const emycEndpoints = {
  paymentQuery: "emycApp/services/searchEmycPnr",
  payment: "emycApp/services/payEmycPayment",
};

export const emycConst = [
  {
    title: "EMYC Payment",
    labels: [
      "Select Account Number",
      "Enter Bill ID",
      "Search",
      "Bill ID",
      "Amount",
      "Full Name",
      "Continue",
    ],
    confirmationTitle: "Confirm EMYC payment",
  },
  {
    title: "የEMYC ክፍያ",
    labels: [
      "የሂሳብ ቁጥር ይምረጡ",
      "የክፍያ መለያ ያስገቡ",
      "ፈልግ",
      "የክፍያ መለያ",
      "መጠን",
      "ሙሉ ስም",
      "ቀጥል",
    ],
    confirmationTitle: "የEMYC ክፍያን ያረጋግጡ",
  },
  {
    title: "Kaffaltii EMYC",
    labels: [
      "Lakkoofsa Herregaa Filadhu",
      "Bill ID Galchi",
      "Barbaadi",
      "Bill ID",
      "Baay'ina",
      "Maqaa Guutuu",
      "Itti Fufi",
    ],
    confirmationTitle: "Kaffaltii EMYC mirkaneessi",
  },
  {
    title: "ክፍሊት EMYC",
    labels: [
      "ቁጽሪ ሕሳብ ምረጽ",
      "Bill ID ኣእትው",
      "ድለ",
      "Bill ID",
      "መጠን",
      "ሙሉእ ስም",
      "ቀጽል",
    ],
    confirmationTitle: "ክፍሊት EMYC ኣረጋግጽ",
  },
  {
    title: "Bixinta EMYC",
    labels: [
      "Xisaab Nambarka Dooro",
      "Geli Bill ID",
      "Raadi",
      "Bill ID",
      "Qadarka",
      "Magaca oo Dhan",
      "Sii Soco",
    ],
    confirmationTitle: "Xaqiiji bixinta EMYC",
  },
  {
    title: "EMYC Mekla",
    labels: [
      "Hisab Nummara Yokale",
      "Bill ID Culusa",
      "Gexso",
      "Bill ID",
      "Qadaana",
      "Migaq Kibuk",
      "Itteh",
    ],
    confirmationTitle: "EMYC mekla asmatis",
  },
];
